import { useI18n } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconStar } from '@change-corgi/design-system-legacy/icons';

import { SelectionCard } from 'src/app/shared/components/payments';

import { useImpressionAmountButton } from './hooks/useImpressionAmountButton';

type Props = {
	buttonAmount: number;
};

const IconStar = () => {
	return <Icon icon={iconStar} size="m" />;
};

export function ImpressionAmountButton({ buttonAmount }: Props): React.JSX.Element {
	const {
		data: { currencyCode, isSelected, impressionCount, isBonusCpm, baseImpressionCount, isDouble },
		actions: { setAmount },
	} = useImpressionAmountButton(buttonAmount);
	const { translate, localizeNumber, translatePlural, localizeCurrency } = useI18n();

	return (
		<SelectionCard
			data-qa="suggested-amount-button"
			type="itemPrice"
			metaText={isBonusCpm ? String(baseImpressionCount) : undefined}
			selected={isSelected}
			value={buttonAmount}
			localizedValue={localizeCurrency(buttonAmount, currencyCode)}
			label={translatePlural('corgi.co.promote.impression_button_label', impressionCount, {
				impressionCount: localizeNumber(impressionCount),
			})}
			onClick={() => setAmount(buttonAmount)}
			badge={
				isBonusCpm
					? {
							position: 'bottom',
							label: translate(
								`fe.pages.sponsors.amount_button_impressions_badge_label.${isDouble ? 'double' : 'bonus'}`,
							),
							icon: <IconStar />,
						}
					: undefined
			}
		/>
	);
}
